module.exports = __webpack_public_path__ + "img/horizontal_3_5_0.5b60895e.png";